import Contact from "../pages/Contact";
import Landing from "../pages/Landing";
import Terms from "../pages/Terms";
import Conformation from "../pages/events/Conformation";
import Event from "../pages/events/Event";
import Gallery from "../pages/galleries/Gallery";
import GalleryList from "../pages/galleries/GalleryList";
import Etoken from "../pages/Etoken";
import DinnerAndShow from "../pages/DinnerAndShow";
import UpcomingEvents from "../pages/UpcomingEvents";
import Unsubscribe from "../pages/Unsubscribe";

const routes = [
  {
    name: "Home",
    path: "/",
    outside: false,
    exact: true,
    Element: <Landing />,
  },
  {
    name: "Dinner & A Show",
    path: "/dinner-and-show",
    outside: false,
    exact: true,
    Element: <DinnerAndShow />,
  },

  {
    name: "Events",
    path: "/events",
    outside: false,
    exact: true,
    Element: <UpcomingEvents />,
  },
  {
    name: "Event",
    path: "/events/event/:slug",
    outside: false,
    exact: true,
    dynamic: true,
    Element: <Event />,
  },
  {
    name: "Conformation",
    path: "/events/confirmation/:user/:event",
    outside: false,
    exact: true,
    dynamic: true,
    Element: <Conformation />,
  },
  // {
  //   name: "Gallery",
  //   path: "/galleries",
  //   outside: false,
  //   exact: true,
  //   Element: <GalleryList />,
  // },
  // {
  //   name: "Gallery",
  //   path: "/galleries/:slug",
  //   outside: false,
  //   exact: true,
  //   dynamic: true,
  //   Element: <Gallery />,
  // },
  {
    name: "Contact",
    path: "/contact",
    outside: false,
    exact: true,
    Element: <Contact />,
  },
  {
    name: "Terms",
    path: "/terms",
    outside: false,
    exact: true,
    Element: <Terms />,
  },
  {
    name: "E Coin",
    path: "/e_coin",
    outside: false,
    exact: true,
    Element: <Etoken />,
  },
  {
    name: "Unsubscribe",
    path: "/unsubscribe",
    outside: false,
    exact: true,
    Element: <Unsubscribe />,
  },
];

export default routes;
